import { Image, Modal } from "react-bootstrap"
import { useEffect, useState } from "react"
import { DonorService } from "../../Services/Donor.Service"
import { formatDate, formatTime, formatCurrency } from "../../Utils/Common"
import Loader from "../../Components/Loader";

function JobDetailsPopup({ show, onHide, donation, title = "Job Details:" }) {

    const [loading, setLoading] = useState(true);
    const [jobDetails, setJobDetails] = useState();

    useEffect(() => { 

        setLoading(true);
        const params = {
            request_id: donation?.request_id,
            interval_id: donation?.interval_id,
            is_matched: donation?.matched_sample,
            ...(donation?.matched_sample === "no" && { sample_id: donation?.sample_ids })
        };        
        
        DonorService.getJobsDetails(params)
            .then((response) => { 
            const jobsDetails = response.jobs; 
            setJobDetails(jobsDetails);  
        })
        .catch((error) => {
            console.error("Failed to fetch donation details", error); 
        })
        .finally(() => {
            setLoading(false);
        });

    }, [donation]);
    
    return (

        <>
            <Loader loading={loading}/>
            <Modal show={show} centered onHide={onHide} dialogclassname="el-deactivate-modal" backdrop="static">
                    <Modal.Body>                
                        <div className="p-3">
                            <h5 className='mb-4'><b>{title}</b></h5>
                            <DetailItem
                                title="Date"                           
                                detail= {formatDate(jobDetails?.sample_pickup_date)}
                            />

                            <DetailItem
                                title="Time"
                                detail={formatTime(jobDetails?.time_interval)}
                            />

                            <DetailItem
                                title="Appointment Length"
                                detail={`${jobDetails?.donation_duration} minutes`}
                            />

                            <DetailItem
                                title="Location" 
                                // detail={`${jobDetails?.lab_name} ${jobDetails?.city ? `, ${jobDetails?.city}` :''}  ${jobDetails?.state ? `, ${jobDetails?.state}` :''} ${jobDetails?.country ? `, ${jobDetails?.country}` :''}` }
                                detail={`${jobDetails?.lab_name}${jobDetails?.city ? `, ${jobDetails?.city}` :''}${jobDetails?.state ? `, ${jobDetails?.state}` :''}${jobDetails?.country ? `, ${jobDetails?.country}` :''}` }

                            />
                            {jobDetails?.rq_samples && (
                                <>
                                    <DetailItem
                                        title="Sample Type"
                                        detail={jobDetails?.rq_samples
                                            .map((sample) =>
                                                `${sample.name} ${sample?.sample_volume && sample.sample_volume !== null ? `${sample.sample_volume} mL` : ""}`
                                            )
                                            .join(", ")}
                                    />
                                </>
                            )}
                            <DetailItem
                                title="Total Compensation"
                                detail={formatCurrency(jobDetails?.total_sample_cost)}
                            />

                            {/* <DetailItem
                                title="Notes"
                                detail={`, ${jobDetails?.description_notes}`}
                                type="notes"
                            /> */}
                            <DetailItem
                                title="Notes" 
                            />
                            <div className="mb-1">
                            {jobDetails?.rq_samples.map((sample, index) => (
                                sample.instruction ? (
                                    <div key={sample.id || index} className="el-content-detail">
                                        <div className="el-request-detail-profile-title">
                                            <b>{sample.name}</b>:
                                            <span className="el-request-detail-profile-name"> {sample.instruction}</span>
                                        </div>
                                    </div>
                                ) : null
                            ))}
                            </div>
                            {jobDetails?.description_notes
                                .split(",")
                                .filter(note => note.trim() && !note.trim().endsWith(":")) // Filter out empty or incomplete notes
                                .map((note, index) => (
                                    <div
                                        key={index}
                                        dangerouslySetInnerHTML={{ __html: note.trim() }}
                                    ></div>
                                ))
                            } 
                        </div>
                        <div className="p-3 " style={{ border: '1px solid red', borderRadius: '5px' }}>
                            <h5><b>General Requirements:</b></h5>
                            <div> 
                                <DetailItem
                                    title="Smokers Allowed?"
                                    detail={jobDetails?.smoker_allowed == 'yes' ? 'Yes' : 'No' || '-'}
                                />

                                <DetailItem
                                    title="Vitamins & Herbal Supplements allowed"
                                    detail={jobDetails?.herbal_vitamins == 'yes' ? 'Yes' : 'No' || '-'}
                                /> 

                                <DetailItem
                                    title="All Medications Allowed?"
                                    detail={jobDetails?.medication_allowed == 'yes' ? 'Yes' : 'No' || '-'}
                                />

                                {jobDetails?.medication_allowed == 'no' && (
                                    <DetailItem
                                        title="Excluded Medications"
                                        detail={jobDetails?.medication_reason || '-'}
                                    />
                                )}

                                {jobDetails?.herbal_vitamins == 'no' && (
                                    <DetailItem
                                        title="Minimum time since last dose of vitamins/supplements or medications"
                                        detail={jobDetails?.herbal_vitamin_note || '-'}
                                    />
                                )}

                                <DetailItem
                                    title="Donor Restrictions"
                                    detail={jobDetails?.donor_restriction_note || '-'}
                                /> 

                            </div>
                        </div>                   
                        <div className="d-flex my-3 w-fit-content justify-content-start">                   
                            <button type="button" onClick={ ()=>{onHide()}} className="btn"><span>Close</span></button>
                        </div>                    
                    </Modal.Body>
            </Modal>  
        </>
    )
}

export default JobDetailsPopup
function DetailItem({ iconSrc, title, detail, type}) {

    let formattedDetail = '';
    if(type) {
        formattedDetail = detail?.replace(/,/g, '<br />');
    } else {
        formattedDetail = detail;
    }

    return (
        <div className="el-flex-area mb-1">
              {iconSrc != null && ( <div className="location-icon">
                <Image src={iconSrc} alt="" className="me-3" />
            </div>)}
            <div className="el-content-detail">
                <h6 className="el-request-detail-profile-title"><b>{title}</b> : <span className="el-request-detail-profile-name" dangerouslySetInnerHTML={{ __html: formattedDetail }} /></h6>
            </div>
        </div>
    );
} 